<template>
  <div class="popup-item" @click.prevent="onClickPopupItem">
    <div
      class="item-thumbnail"
      :style="{
        'background-image': item.thumbnailUrl
          ? `url(${item.thumbnailUrl})`
          : null,
      }"
    ></div>
    <div class="item-detail">
      <h5 class="item-title">{{ item.title | truncate(30) }}</h5>
      <item-attributes :item="item" />
    </div>
    <div class="item-status">
      <div
        class="sub-status outgoing-status"
        :style="{
          'background-image': getStatusImageUrl(item.outgoingAffiliationStatus),
        }"
        :class="{
          'status-pending': item.outgoingAffiliationStatus === 'pending',
          'status-approved': item.outgoingAffiliationStatus === 'approved',
          'status-rejected': item.outgoingAffiliationStatus === 'rejected',
        }"
      ></div>
      <div
        class="sub-status incoming-status"
        :style="{
          'background-image': getStatusImageUrl(item.incomingAffiliationStatus, true),
        }"
        :class="{
          'status-pending': item.incomingAffiliationStatus === 'pending',
          'status-approved': item.incomingAffiliationStatus === 'approved',
          'status-rejected': item.incomingAffiliationStatus === 'rejected',
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import approvedIcon from "@/assets/images/icons/ew-icon_approved.svg";
import rejectedIcon from "@/assets/images/icons/ew-icon_rejected.svg";
import pendingIcon from "@/assets/images/icons/ew-icon_pending.svg";
import addIcon from "@/assets/images/icons/ew-icon_add.svg";
import ItemAttributes from "./ItemAttributes.vue";

export default {
  components: {
    ItemAttributes,
  },
  props: {
    item: {
      type: Object,
      default() {
        return {
          name: "",
          owner: {
            id: "",
            fullName: "",
          },
          launchedDate: "",
          type: "",
          stats: {
            experienceCount: 0,
          },
          fee: 0,
          thumbnailUrl: "",
        };
      },
    },
  },
  methods: {
    getFormatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    getReadableDateTime(date) {
      return moment(date).fromNow();
    },
    getReadableType(type) {
      switch (type) {
        case "destination":
          return "Destination Page";
        case "thematic":
          return "Thematic Page";
        case "brand":
          return "Brand Page";
        case "regional":
          return "Regional Page";
        default:
          return "Others";
      }
    },
    getDecimalFormat(number) {
      return typeof number === "number" ? number.toLocaleString("en-US") : "0";
    },
    getFee(number) {
      return number === 0 ? "Free" : this.getDecimalFormat(number);
    },
    getStatusImageUrl(status, hideAdd = false) {
      let url = "";
      switch (status) {
        case "approved":
          url = `url(${approvedIcon})`;
          break;
        case "rejected":
          url = `url(${rejectedIcon})`;
          break;
        case "pending":
          url = `url(${pendingIcon})`;
          break;
        default:
          url = hideAdd ? 'initial' : `url(${addIcon})`;
      }
      return url;
    },
    onClickPopupItem() {
      this.$emit("click", this.item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.popup-item {
  background-color: white;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.16);
  display: flex;
  cursor: pointer;
  user-select: none;

  .item-title {
    font-size: 18px;
    font-weight: normal;
  }

  .item-thumbnail {
    width: 130px;
    height: 157px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    flex: 0 0 auto;
  }

  .item-detail {
    flex: 1 1 auto;
    padding: 5px 20px;

    .item-attribute {
      display: flex;
    }
    .attribute-label {
      font-weight: bold;
      width: 100px;
      margin-right: 10px;
    }
    .attribute-fee .attribute-value,
    .attribute-type .attribute-value {
      text-transform: uppercase;
    }
  }

  .last-updated {
    margin-top: 20px;
  }

  .item-status {
    width: 45px;
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;

    .sub-status {
      height: 50%;
      background-color: var(--color-light-gray);
      background-size: 60%;
      background-position: center;
      position: relative;

      & + .sub-status {
        border-top: 1px solid white;
      }

      &.status-pending {
        background-color: var(--color-gray);
      }

      &.status-approved {
        background-color: var(--color-blue-sky);
      }

      &.status-rejected {
        background-color: var(--color-red);
      }

      &.outgoing-status::before {
        content: "";
        display: block;
        position: absolute;
        left: -17px;
        top: 0;
        width: 0;
        height: 0;
        border-style: solid;
        border-color: transparent;
        border-width: 16px 8px;
        border-right-color: var(--color-light-gray);
      }

      &.incoming-status::before {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 0;
        height: 0;
        border-style: solid;
        border-color: transparent;
        border-width: 16px 8px;
        border-left-color: white;
      }
    }
  }
}
</style>